import {Component} from '@angular/core';

import {ModalService} from '@services/modal/modal.service';

@Component({
    selector: 'scitis-webgl-page',
    templateUrl: './webgl-page.component.html',
    styleUrls: ['./webgl-page.component.scss'],
    standalone: false
})
export class WebglPageComponent {

  constructor(private modalService: ModalService) {
  }

  openXL(content) {
    this.modalService.open(content, {size: 'xl', ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {
    });
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {
    });
  }
}
